import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { BsFileEarmarkExcelFill } from "react-icons/bs";

const DownloadExcel = ({ tableRef, fileName = "export" }) => {
  const exportTableToExcel = () => {
    const tableEl = tableRef?.current;
    if (!tableEl) {
      console.warn("No table element found to export");
      return;
    }

    // Clone table so we can modify it safely
    const clonedTable = tableEl.cloneNode(true);

    // Convert time values like "2286:00:00" to plain text
    const timeRegex = /^\d{2,}:\d{2}:\d{2}$/;
    clonedTable.querySelectorAll("td").forEach((td) => {
      if (timeRegex.test(td.innerText)) {
        td.innerText = `'${td.innerText}`; // Add leading apostrophe to force plain text in Excel
      }
    });

    const workbook = XLSX.utils.table_to_book(clonedTable);
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${fileName}-Railsetu.xlsx`);
  };

  return (
    <div className="d-flex justify-content-end">
      <button
        type="button"
        onClick={exportTableToExcel}
        className="btn btn-sm btn-outline-success d-flex align-items-center"
      >
        <BsFileEarmarkExcelFill style={{ marginRight: 4 }} />
        Download Table
      </button>
    </div>
  );
};

export default DownloadExcel;
